import React, {useRef, useEffect, useCallback} from 'react';
import {useSelector} from 'react-redux';
import fp from 'lodash/fp';
import {Link, useHistory} from 'react-router-dom';

import {useApi, ducks, components} from '@arborian/narrf';

import {url_for} from 'ccm/routes';
import {selectCurrentUser} from 'ccm/lib/selectors-ccm';

import BasePage from 'ccm/components/BasePage';
import TelecomChips from 'ccm/components/TelecomChips';

const {
    DataTable,
    Column,
    Action,
    useLocationFetchOptions,
    updateLocationFetchOptions,
} = components;

const defaultFetchOptions = {
    // filter: {},
    // sort: {},
    page: {size: 20},
};

function NameColumnComponent({row}) {
    return (
        <Link to={url_for('practice', {practiceId: row.data.id})}>
            {fp.get('attributes.name', row.data)}
        </Link>
    );
}
export default function PracticesPage() {
    const api = useApi();
    const history = useHistory();
    const tableRef = useRef();
    const curUser = useSelector(selectCurrentUser);
    const rel = useSelector(ducks.jsonapi.selectRelated(curUser));
    const hashPrefix = 'pracTable.';
    const practiceUrl = fp.get(
        'relationships.practices.links.related',
        curUser,
    );

    const fetchOptions = useLocationFetchOptions(
        defaultFetchOptions,
        hashPrefix,
    );
    const onChangeFetchOptions = useCallback(
        o => {
            const newParams = updateLocationFetchOptions(o, hashPrefix);
            history.push('?' + newParams.toString());
        },
        [history, hashPrefix],
    );

    const fetchPractices = useCallback(
        async fetchOptions => {
            if (!practiceUrl) return {data: [], page: 0, totalCount: 0};
            const result = await api.fetchDataTable(practiceUrl, fetchOptions);
            console.log('... result was', result);
            return result;
        },
        [api, practiceUrl],
    );

    const refresh = useCallback(() => tableRef.current.fetch(), [tableRef]);

    useEffect(() => {
        if (rel.practices && rel.practices.length === 1) {
            history.push(
                url_for('practice', {practiceId: rel.practices[0].id}),
            );
        }
    }, [rel, history]);

    return (
        <BasePage wide title='Practices'>
            <DataTable
                title='My Practice(s)'
                size='small'
                data={fetchPractices}
                tableRef={tableRef}
                fetchOptions={fetchOptions}
                onChangeFetchOptions={onChangeFetchOptions}
                options={{search: true}}
            >
                <Column
                    title='Name'
                    field='attributes.name'
                    component={NameColumnComponent}
                />
                <Column title='Address' field='attributes.address.oneLine' />
                <Column
                    title='Telecom'
                    field='attributes.telecom'
                    component={TelecomChips}
                />
                <Column title='Email' field='attributes.email.email' />

                <Action
                    name='refresh'
                    free
                    onClick={refresh}
                    tooltip='Refresh'
                    icon='refresh'
                />
            </DataTable>
        </BasePage>
    );
}
